<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <MtcSearch ref="mtcSearch"
                 v-model="queryParam"
                 :filterList="filterList"
                 :optionsData="optionsData" />
    </div>
    <!-- 查询区域-END -->
    <!-- table区域-begin -->
    <BaseTable ref="baseTable"
               @searchReset="searchReset"
               :mainTable="mainTable"
               :tableColumns="columns"
               :tableData="tableData">
      <!-- 左侧操作按钮 -->
      <template #leftButton>
        <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('button.add') }}</a-button>
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel">
              <a-icon type="delete" />
              {{ $t('button.delete') }}
            </a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px"> {{ $t('button.batchOperation') }}
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </template>
      <!-- 操作列 -->
      <span slot="action" slot-scope="{ record }">
          <!-- 编辑 -->
          <a @click="handleEdit(record)">{{ $t('button.edit') }}</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('button.more') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{ $t('button.details') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('button.delete') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
    </BaseTable>
    <tenant-modal ref="modalForm" @ok="submitCallBack" />
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import TenantModal from './modules/TenantModal'
import { MTC_AUTH } from '@api/servers'
import { BaseTable, MtcSearch } from '@comp/mtcModule'
import { getAction } from '@api/manage'
import { FormTypes } from '@/utils/JEditableTableUtil'

export default {
  name: 'TenantList',
  title: '租户管理',
  mixins: [JeecgListMixin],
  components: {
    TenantModal,
    BaseTable,
    MtcSearch
  },
  data() {
    return {
      mainTable: 'sys_tenant',
      // 列表接口
      tableData: params => this.getData(params),
      // 列表查询条件
      queryParam: {},
      // 表头
      columns: [
        {
          title: '租户名称',
          align: 'center',
          dataIndex: 'name'
        },
        {
          title: '租户编号',
          align: 'center',
          dataIndex: 'preCode'
        },
        {
          title: '开始时间',
          align: 'center',
          dataIndex: 'beginDate'
        },
        {
          title: '结束时间',
          align: 'center',
          dataIndex: 'endDate'
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status_dictText'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      filterList: [
        {
          // 字段名称
          label: '租户名称',
          // 字段编码
          key: 'name',
          // 输入值
          value: '',
          // 字段类型
          type: FormTypes.input,
          // 多语言key
          languageKey: '',
          // 提示语
          placeholder: ''
        },
        {
          // 字段名称
          label: '租户编号',
          // 字段编码
          key: 'preCode',
          // 输入值
          value: '',
          // 字段类型
          type: FormTypes.input,
          // 多语言key
          languageKey: '',
          // 提示语
          placeholder: ''
        },
        {
          // 字段名称
          label: '状态',
          // 字段编码
          key: 'status',
          // 输入值
          value: '',
          // 是否多选
          isMultiple: false,
          // 最大展示多选个数
          maxTagCount: 3,
          // 字段类型
          type: FormTypes.select,
          // 匹配下拉框数据的key
          optionKey: '',
          // 多语言key
          languageKey: '',
          // 提示语
          placeholder: ''
        }
      ],
      optionsData: {
        status: [
          {
            label: '正常',
            value: 1
          },
          {
            label: '冻结',
            value: 0
          }
        ]
      },
      url: {
        list: `${MTC_AUTH}sys/tenant/list`,
        delete: `${MTC_AUTH}/sys/tenant/delete`,
        deleteBatch: `${MTC_AUTH}/sys/tenant/deleteBatch`
      }
    }
  },
  methods: {
    // 重置查询条件
    searchReset() {
      this.queryParam = {}
      this.$refs.baseTable.refresh()
    },
    // 列表接口
    getData(baseParams) {
      let params = {
        ...baseParams,
        ...this.queryParam
      }
      return getAction(this.url.list, params)
    },
    // 关闭模态框回调
    submitCallBack() {
      this.$refs.baseTable.refresh()
      this.$refs.baseTable.clearSelected()
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>